// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import CopyLinkController from "./copy_link_controller"
application.register("copy-link", CopyLinkController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import LineItemsController from "./line_items_controller"
application.register("line-items", LineItemsController)

import LoadingController from "./loading_controller"
application.register("loading", LoadingController)

import LocalTimeController from "./local_time_controller"
application.register("local-time", LocalTimeController)

import LocalTimeShortController from "./local_time_short_controller"
application.register("local-time-short", LocalTimeShortController)

import MobileMenuController from "./mobile_menu_controller"
application.register("mobile-menu", MobileMenuController)

import ProposalStatusController from "./proposal_status_controller"
application.register("proposal-status", ProposalStatusController)

import RevealController from "./reveal_controller"
application.register("reveal", RevealController)

import SortableController from "./sortable_controller"
application.register("sortable", SortableController)
